import React, { useCallback } from "react";
import { ErrorMessage, Field, FieldInputProps, FormikProps, getIn } from "formik";
import TextCell from "./TextCell";
import NumberCell from "./NumberCell";
import CurrencyCell from "./CurrencyCell";
import SelectCell from "./SelectCell";
import CheckboxCell from "./CheckboxCell";
import DateCell from "./DateCell";

interface CellProps {
  colIndex: number;
  column: any;
  index: number;
  fieldName: string;
  // isThresholdPercentMode: Record<number, boolean>;
  // isAwardPercentMode: Record<number, boolean>;
  // setIsThresholdPercentMode: (value: Record<number, boolean>) => void;
  // setIsAwardPercentMode: (value: Record<number, boolean>) => void;
}

const FinancesTableCell: React.FC<CellProps> = ({
  colIndex,
  column,
  index,
  fieldName,
  // isThresholdPercentMode,
  // isAwardPercentMode,
  // setIsThresholdPercentMode,
  // setIsAwardPercentMode,
}) => {
  // Define ThresholdCell inline
  // const ThresholdCell = ({ field, onBlur }: { field: any; onBlur: (e: React.FocusEvent<any>) => void }) => (
  //   <div className="flex items-center gap-2">
  //     <div className="flex rounded-md border">
  //       <button
  //         type="button"
  //         className={`px-2 py-1 ${!isThresholdPercentMode[index] ? "bg-gray-200" : "bg-white"}`}
  //         onClick={() => {

  //           setIsThresholdPercentMode({ ...isThresholdPercentMode, [index]: !isThresholdPercentMode[index] })
  //         }}
  //       >
  //         #
  //       </button>
  //       <button
  //         type="button"
  //         className={`px-2 py-1 ${isThresholdPercentMode[index] ? "bg-gray-200" : "bg-white"}`}
  //         onClick={() => setIsThresholdPercentMode({ ...isThresholdPercentMode, [index]: !isThresholdPercentMode[index] })}
  //       >
  //         %
  //       </button>
  //     </div>
  //     <NumberCell {...field} onBlur={onBlur} isPercentage={isThresholdPercentMode[index]} />
  //   </div>
  // );

  // Define AwardCell inline
  // const AwardCell = ({ field, onBlur }: { field: any; onBlur: (e: React.FocusEvent<any>) => void }) => (
  //   <div className="flex items-center gap-2">
  //     <div className="flex rounded-md border">
  //       <button
  //         type="button"
  //         className={`px-2 py-1 ${!isAwardPercentMode[index] ? "bg-gray-200" : "bg-white"}`}
  //         onClick={() => setIsAwardPercentMode({ ...isAwardPercentMode, [index]: !isAwardPercentMode[index] })}
  //       >
  //         $
  //       </button>
  //       <button
  //         type="button"
  //         className={`px-2 py-1 ${isAwardPercentMode[index] ? "bg-gray-200" : "bg-white"}`}
  //         onClick={() => setIsAwardPercentMode({ ...isAwardPercentMode, [index]: !isAwardPercentMode[index] })}
  //       >
  //         %
  //       </button>
  //     </div>
  //     <NumberCell {...field} onBlur={onBlur} isPercentage={isAwardPercentMode[index]} />
  //   </div>
  // );

  const renderComponent = useCallback(
    (
      field: FieldInputProps<number>,
      form: FormikProps<any>,
      hasError: boolean
    ) => {
      const onBlur = (e: React.FocusEvent<any>) => {
        field.onBlur(e);
        if (form.dirty) {
          form.handleSubmit(e);
        }
      };

      const componentMap: { [key: string]: () => JSX.Element } = {
        text: () => <TextCell {...field} onBlur={onBlur} hasError={hasError} />,
        number: () => (
          <NumberCell {...field} onBlur={onBlur} hasError={hasError} />
        ),
        currency: () => (
          <CurrencyCell {...field} onBlur={onBlur} hasError={hasError} />
        ),
        select: () => (
          <SelectCell
            {...field}
            options={column.selectOptions || []}
            onBlur={onBlur}
          hasError={hasError}
          />
        ),
        checkbox: () => (
          <CheckboxCell {...field} onBlur={onBlur} hasError={hasError} form={form}/>
        ),
        date: () => <DateCell {...field} onBlur={onBlur}  hasError={hasError}/>,
        // threshold: () => <ThresholdCell field={field} onBlur={onBlur} hasError={hasError}/>,
        // award: () => <AwardCell field={field} onBlur={onBlur} hasError={hasError}/>,
      };

      return (
        componentMap[column.type as string]?.() || (
          <TextCell {...field} onBlur={onBlur} hasError={hasError} />
        )
      );
    },
    [column, index]

    // [column, index, isThresholdPercentMode, isAwardPercentMode, setIsThresholdPercentMode, setIsAwardPercentMode]
  );

  return (
    <Field name={fieldName}>
      {({
        field,
        form,
      }: {
        field: FieldInputProps<any>;
        form: FormikProps<any>;
      }) => {
        const error = getIn(form.errors, fieldName);
        const touched = getIn(form.touched, fieldName);
        const hasError = !!(error && touched);

        return (
          <td
            className={`flex-1 px-2 h-10 truncate whitespace-nowrap overflow-hidden relative ${
              hasError ? "border-2 border-red-500 rounded-md" : ""
            }`}
          >
            {renderComponent(field, form, hasError)}
            <ErrorMessage
              name={fieldName}
              component="div"
              className="text-red-500 text-xs absolute bottom-0 text-center mt-2"
            />
          </td>
        );
      }}
    </Field>
  );
};

export default FinancesTableCell;
